import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
export default {
  data: function data() {
    return {
      searchForm: {},
      // 搜索表单
      tableLoading: false,
      tableData: [],
      // 表格数据

      // 表单
      form: {
        price: "",
        // 价格
        cycle: "",
        // 周期
        currencyId: "" // 货币
      },
      curCity: {},
      // 当前城市短信极速通知的配置
      currencyList: [],
      // 货币列表
      priceList: [],
      // 价格/周期列表
      dialogVisible: false,
      // 弹窗状态
      dialogPriceVisible: false // 弹窗状态
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getSmsCurrencyList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    // 更新状态
    updateStatus: function updateStatus(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.updateSms({
                id: row.id,
                status: row.status == 1 ? 2 : 1
              });
            case 1:
              _this2.$message.success("操作成功");
              _this2.dialogVisible = false;
              _this2.getData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    // 保存 价格周期
    savePrice: function savePrice() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              res = null;
              _this3.form.cityId = _this3.curCity.cityId;
              if (!_this3.form.id) {
                _context3.n = 2;
                break;
              }
              _context3.n = 1;
              return _this3.$api.updateSmsPrice(_this3.form);
            case 1:
              res = _context3.v;
              _context3.n = 4;
              break;
            case 2:
              _context3.n = 3;
              return _this3.$api.addSmsPrice(_this3.form);
            case 3:
              res = _context3.v;
            case 4:
              _this3.dialogPriceVisible = false;
              _this3.getSmsPriceByCity(_this3.curCity.cityId);
            case 5:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    updatePriceDialog: function updatePriceDialog(row) {
      row.cycle = String(row.cycle);
      this.form = row;
      this.dialogPriceVisible = true;
    },
    // 获取当前城市价格周期
    getSmsPriceByCity: function getSmsPriceByCity(cityId) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this4.$api.getSmsPriceByCity({
                cityId: cityId
              });
            case 1:
              res = _context4.v;
              _this4.priceList = res.data;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    // 删除价格周期
    deletePrice: function deletePrice(row) {
      var _this5 = this;
      this.$confirm("删除当前价格/周期，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this5.$api.deleteSmsPrice({
                id: row.id
              });
            case 1:
              _this5.$message.success("操作成功");
              _this5.getSmsPriceByCity(_this5.curCity.cityId);
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      })));
    },
    // 获取货币列表
    getSmsCurrencyList: function getSmsCurrencyList() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this6.$api.getSmsCurrencyList();
            case 1:
              res = _context6.v;
              _this6.currencyList = res.data;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    // 初始化
    initSms: function initSms() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return _this7.$api.initSms();
            case 1:
              _this7.$message.success("操作成功");
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    getData: function getData() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _this8.tableLoading = true;
              _context8.n = 1;
              return _this8.$api.getSmsList();
            case 1:
              res = _context8.v;
              _this8.tableData = res.data;
              _this8.tableLoading = false;
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    updateDialog: function updateDialog(row) {
      this.curCity = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
      this.getSmsPriceByCity(row.cityId);
    }
  }
};